import Tick from '../../atoms/icons/Tick';
import styles from './Tabs.module.scss';
import { useTabsContext } from './useTabsContext';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';

/**
 * This component allows changing of the active Tab.
 */
export const TabTitle = ({
  onClick = () => null,
  index = '1',
  children = '',
  'aria-controls': ariaControls = '',
}) => {
  const { setActiveTab, activeTab, animateLine, isAnimating, isCheckoutTab } =
    useTabsContext();
  const isSelected = index === activeTab;

  return (
    <div
      className={clsx(styles.tabTitle, {
        [` ${styles.tabSelected}`]: isSelected,
        [` ${styles.animated}`]: isAnimating,
        [` ${styles.checkoutTab}`]: isCheckoutTab,
      })}
      data-tabindex={index}
      aria-controls={ariaControls}
      role="tab"
      aria-selected={isSelected ? 'true' : 'false'}
      onClick={() => onClick(children)}
    >
      <button
        type="button"
        onClick={() => {
          if (!isAnimating && activeTab !== index) {
            setActiveTab(index);
            !isCheckoutTab && animateLine(activeTab, index);
          }
        }}
      >
        {isSelected && isCheckoutTab && (
          <Tick className={styles.tick} width="20" height="17" isTabTick />
        )}
        {children}
      </button>
    </div>
  );
};

TabTitle.propTypes = {
  onClick: PropTypes.func,
  index: PropTypes.string,
  children: PropTypes.node,
  'aria-controls': PropTypes.node,
};

TabTitle.displayName = 'TabTitle';
